interface GetPaginationPagesParams {
  currentPage: number;
  totalPages: number;
  padding: number;
}

// 1-based port of instantsearch.js' Paginator: a window of up to `2 * padding + 1` pages around
// the current one, shifted to stay within [1, totalPages] near either end.
export const getPaginationPages = ({ currentPage, totalPages, padding }: GetPaginationPagesParams): number[] => {

  const displayedPagesCount = Math.max(0, Math.min(2 * padding + 1, totalPages));
  const firstPage = Math.max(1, Math.min(currentPage - padding, totalPages - displayedPagesCount + 1));

  return Array.from({ length: displayedPagesCount }, (_, index) => firstPage + index);

};
